import { UserManager, Log, OidcClientSettings } from 'oidc-client-ts';
import { Logger } from '../logger';
import { getAppContainer } from '../container';

/**
 * @private
 * @hidden
 * @param location
 */
export const hasCodeInUrl = (location: Location): boolean => {
  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(location.hash.replace('#', '?'));

  return Boolean(
    searchParams.get('code') ||
      searchParams.get('id_token') ||
      searchParams.get('session_state') ||
      hashParams.get('code') ||
      hashParams.get('id_token') ||
      hashParams.get('session_state'),
  );
};

export const initUserManager = (
  configuration: Omit<OidcClientSettings, 'redirect_uri' | 'post_logout_redirect_uri'>,
): UserManager => {
  const userManager = new UserManager({
    ...configuration,
    redirect_uri: window.location.origin,
    post_logout_redirect_uri: window.location.origin,
    automaticSilentRenew: true,
  });

  userManager.events.addSilentRenewError(async () => {
    await userManager.signoutRedirect();
  });
  userManager.events.addUserLoaded(async () => {
    const session = await userManager.getUser();
    getAppContainer().session.set(session);
  });
  userManager.events.addUserUnloaded(() => {
    getAppContainer().session.set(null);
  });

  const isDev = process.env.NODE_ENV === 'development';

  if (isDev) {
    const logger = new Logger('User Manager');
    Log.setLogger(logger);
  }
  return userManager;
};
